// source: pbtypes/gen/vehicle_params_for_phone/return_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.vehicle_params_for_phone.ReturnSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.ReturnSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.ReturnSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.ReturnSettings.displayName = 'proto.vehicle_params_for_phone.ReturnSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.ReturnSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.ReturnSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.ReturnSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
minimumHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
waitTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
waitTimeBeforeLand: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
cancelAttiReturnWaitTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.ReturnSettings}
 */
proto.vehicle_params_for_phone.ReturnSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.ReturnSettings;
  return proto.vehicle_params_for_phone.ReturnSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.ReturnSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.ReturnSettings}
 */
proto.vehicle_params_for_phone.ReturnSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinimumHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWaitTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSpeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWaitTimeBeforeLand(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCancelAttiReturnWaitTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.ReturnSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.ReturnSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.ReturnSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinimumHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getWaitTime();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getWaitTimeBeforeLand();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getCancelAttiReturnWaitTime();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
};


/**
 * optional float minimum_height = 1;
 * @return {number}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.getMinimumHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettings} returns this
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.setMinimumHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float wait_time = 2;
 * @return {number}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.getWaitTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettings} returns this
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.setWaitTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float speed = 3;
 * @return {number}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettings} returns this
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float wait_time_before_land = 4;
 * @return {number}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.getWaitTimeBeforeLand = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettings} returns this
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.setWaitTimeBeforeLand = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float cancel_atti_return_wait_time = 5;
 * @return {number}
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.getCancelAttiReturnWaitTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettings} returns this
 */
proto.vehicle_params_for_phone.ReturnSettings.prototype.setCancelAttiReturnWaitTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
